import moment from "moment/moment";
import useSuiviRecommande from "../../hooks/use-suivi-recommande";
import { Link } from "react-router-dom";
import Spinner from "../UI/Spinner";
import Card from "../UI/Card";
import Callout from "../UI/Callout";
import DocumentDownloader from "../UI/DocumentDownloader";
import { handleAPIError } from "../../utils/index.jsx";
import { useState } from "react";
import useAuthenticatedAxios from "../../hooks/use-authenticated-axios";
import Button from "../UI/Button";
import useLoader from "../../hooks/use-loader";

export default function SuiviRecommande({ file }) {
  const { suiviRecommande, error, isLoading } = useSuiviRecommande(file?.id);
  const axios = useAuthenticatedAxios();

  const [laposteError, setLaposteError] = useState("");

  const [isLoadingReception, generateSignedUrlReception] = useLoader(
    async (setSignedUrl, id_file) => {
      try {
        const response = await axios.get(`/laposte/arn/${id_file}`);
        setSignedUrl(response.data);
      } catch (error) {
        setLaposteError(handleAPIError(error));
      }
    },
  );
  const [isLoadingContenu, generateSignedUrlContenu] = useLoader(
    async (setSignedUrl, id_file) => {
      try {
        const response = await axios.get(`/laposte/pdc/${id_file}`);
        setSignedUrl(response.data);
      } catch (error) {
        setLaposteError(handleAPIError(error));
      }
    },
  );

  const [isLoadingDepot, generateSignedUrlDepot] = useLoader(
    async (setSignedUrl, id_file) => {
      try {
        const response = await axios.get(`/laposte/pdd/${id_file}`);
        setSignedUrl(response.data);
      } catch (error) {
        setLaposteError(handleAPIError(error));
      }
    },
  );

  if (!file) {
    return null;
  }

  const fallback = (
    <div>
      Vous pouvez suivre votre courrier{" "}
      <Link
        to={`https://www.laposte.fr/outils/suivre-vos-envois?code=${file.id_laposte}`}
        target={"_blank"}
      >
        ici
      </Link>
    </div>
  );

  if (error) return fallback;

  if (isLoading) return <Spinner width={"3em"} />;

  const suiviEvents = suiviRecommande.event;

  if (!suiviEvents && !suiviRecommande.returnMessage) return fallback;

  return (
    <div>
      <img
        src={`/photo_historique_laposte.png`}
        alt="La poste"
        className={"center marginB10"}
      />
      {file.laposte_delivered_at ? (
        <h2 className="text-center">
          Votre lettre a été livrée le{" "}
          {moment(file.laposte_delivered_at).format("DD/MM/YYYY")}
        </h2>
      ) : (
        <h2 className={"text-center"}>Votre lettre est en cours d'envoi...</h2>
      )}
      <Card>
        {suiviEvents &&
          suiviEvents.map((ev) => (
            <p>
              <span className={"primaryText"}>
                {moment(ev.date).format("DD/MM/YYYY-HH:mm")} :
              </span>{" "}
              {ev.label}
            </p>
          ))}
        {!suiviEvents && <p>{suiviRecommande.returnMessage}</p>}
      </Card>
      <div className="text-center">
        <DocumentDownloader>
          {(setSignedUrl) => (
            <Button
              onClick={() => generateSignedUrlDepot(setSignedUrl, file.id)}
              isLoading={isLoadingDepot}
              disabled={isLoadingDepot || !file.order_id_laposte}
              className="marginT10"
            >
              Télécharger la preuve de dépôt
            </Button>
          )}
        </DocumentDownloader>
        <DocumentDownloader>
          {(setSignedUrl) => (
            <Button
              isLoading={isLoadingContenu}
              onClick={() => generateSignedUrlContenu(setSignedUrl, file.id)}
              className="marginT10"
            >
              Télécharger la preuve de contenu
            </Button>
          )}
        </DocumentDownloader>
        <DocumentDownloader>
          {(setSignedUrl) => (
            <Button
              disabled={!file.laposte_delivered_at || isLoadingReception}
              onClick={() => generateSignedUrlReception(setSignedUrl, file.id)}
              isLoading={isLoadingReception}
              className="marginT10"
            >
              Télécharger la preuve de réception
            </Button>
          )}
        </DocumentDownloader>
        <Callout variant="danger">{laposteError}</Callout>
      </div>
    </div>
  );
}
